import { React, useEffect, useState } from 'react';
import { BsArrowBarRight } from 'react-icons/bs';
import { logout } from "../../services/auth";
import './styles.css';
import ReactTooltip from 'react-tooltip';

// Importa alerta
import NotificationCustom from '../../components/Notification/NotificationCustom';

import api from '../../services/api';
import Push from '../Notification/Push';

export default function Header() {
	// Permissão do usuário no sistema
	var userPermission;
	switch (localStorage.getItem('Permission')) {
		case 'Admin':
			userPermission = 'admin';
			break;
		case 'Controlador':
			userPermission = 'manager';
			break;
		case 'Executor':
			userPermission = 'executor';
			break;
		default:
			break;
	}

	const userName = localStorage.getItem('NameUser');
	const typeUser = localStorage.getItem('Permission');
	const [infoUser, setInfoUser] = useState([]);
	const [popover, setPopover] = useState("");
	const [notificationCustom, setNotificationCustom] = useState({ isOpen: false, title: '' });

	useEffect(() => {
		api.get(`/profile`).then(res => {

			const areas = [];

			//Quantidade de áreas que será apresentada no cabeçalho
			const quantShowAreas = 3;

			res.data.areas.forEach((area, index) => {
				if (index < quantShowAreas) {
					if (res.data.areas.length > quantShowAreas && index === quantShowAreas - 1)
						areas.push(area + "...");
					else
						areas.push(area);
				}
			})

			setInfoUser(areas);
			setPopover(res.data.areas.join("\n"));

		}).catch((err) => {
			/* Tratativa caso o token expire. O mesmo foi aplicado aqui pelo fato do Header ser usado em todas as páginas */
			if (err.response.status === 401 || err.response.status === 500) {
				setNotificationCustom({
					isOpen: true,
					title: `Sua sessão expirou. Por favor realize um novo login.`,
					onConfirm: () => {
						/* Realiza logout */
						localStorage.removeItem('&app_token');
						window.location.href = '/';
					}
				});
			}
		});
	}, []);

	return (
		<header className='header-pages'>
			<Push />
			<div>
				<span className="name-user">Bem-vindo(a), <b>{userName.split(' ')[0]}</b></span>
				<span className="type-user">Perfil: <strong>{typeUser}</strong></span>
				<br></br>
				{/* Irá exibir essa parte do código somente se o usuário for controlador ou executor */}
				{userPermission === 'manager' || userPermission === 'executor' ?
					<span className="type-user" fontSize="small" data-for="proportion-info-2" data-place="bottom" data-tip={popover}>
						Categorias: {infoUser.map((res, i) => (
							<strong key={res}>
								{res}
								{infoUser[i + 1] ? ', ' : ''}
							</strong>
						))}

					</span>
					: false}
			</div>

			{/*<Link className="button">
       	 <img src={profile} alt="Perfil" className="imagem-profile" />
      </Link>*/}

			<button type="button" onClick={logout}>
				<BsArrowBarRight size={24} color="#155BCB" />
			</button>

			<NotificationCustom
				notificationCustom={notificationCustom}
				setNotificationCustom={setNotificationCustom}
			/>

			<ReactTooltip id="proportion-info-2" className='popup' />
		</header>
	)
}